import { render, staticRenderFns } from "./LicenseCreateForm.vue?vue&type=template&id=372d5753&scoped=true&lang=pug"
import script from "./LicenseCreateForm.vue?vue&type=script&lang=js"
export * from "./LicenseCreateForm.vue?vue&type=script&lang=js"
import style0 from "./LicenseCreateForm.vue?vue&type=style&index=0&id=372d5753&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d5753",
  null
  
)

export default component.exports